export default __webpack_public_path__ + "static/webhook-cd-3e11249c80f1b4c433d67ca1a4f49193.jpg";